import React, { useCallback, useEffect, useState } from 'react';
import icClose from 'Assets/img/ic_x_circle.png';
import icClose2 from 'Assets/img/ic_x_circle@2x.png';
import icClose3 from 'Assets/img/ic_x_circle@3x.png';
import icSearch from 'Assets/img/contract/ic_search.png';
import icSearch2 from 'Assets/img/contract/ic_search@2x.png';
import icSearch3 from 'Assets/img/contract/ic_search@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { useIntl } from 'react-intl';
import { getGoogleMapAutoComplete } from 'Api/endpoints/Common';
import IntlMessages from 'Util/IntlMessages';
import { Dialog } from '@mui/material';
import { getGoogleMapGeocode } from '../../api/endpoints/Common';
import _ from 'lodash';
import { useError } from 'Api/hooks/useError';

const closeButtons = getImageSet([icClose, icClose2, icClose3]);
const searchButtons = getImageSet([icSearch, icSearch2, icSearch3]);
const AddressVietnamPopup = ({ open, onClose, onSelect }) => {
  const { showErrorPopup } = useError();
  const { formatMessage } = useIntl();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [data, setData] = useState([]);
  const [debouncedText, setDebouncedText] = useState('');

  useEffect(() => {
    if (open) {
      setSearchKeyword('');
      setData([]);
    }
  }, [open]);

  const debouncedSearchText = useCallback(
    _.debounce(value => setDebouncedText(value), 300),
    []
  );

  useEffect(() => {
    debouncedSearchText(searchKeyword);
  }, [searchKeyword, debouncedSearchText]);

  const onClickSearch = useCallback(async () => {
    if (debouncedText === '' || debouncedText.length < 2) {
      setData([]);
      return null;
    }
    try {
      const result = await getGoogleMapAutoComplete({ input: debouncedText });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message, onClose });
        return;
      }

      setData(result.data);
    } catch (e) {
      console.log(e);
    }
  }, [debouncedText]);

  useEffect(() => {
    onClickSearch();
  }, [onClickSearch]);

  const fetchGeoCode = async placeId => {
    try {
      const result = await getGoogleMapGeocode({ placeId });
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return null;
      }
      return result.data;
    } catch (e) {
      console.log(e);
    }
  };

  const onSelectItem = async item => {
    const geoCode = await fetchGeoCode(item.placeId);
    if (!geoCode) return;
    const data = {
      address: item.address,
      address2: '',
      latitude: geoCode.latitude,
      longitude: geoCode.longitude,
    };
    onSelect(data);
    onClose();
  };

  // 정규표현식 특수문자를 이스케이프하는 함수
  const escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightSearchKeyword = text => {
    if (!debouncedText) return text;

    const escapedDebouncedText = escapeRegExp(debouncedText);
    const parts = text.split(new RegExp(`(${escapedDebouncedText})`, 'gi'));
    return parts.map((part, i) =>
      part.toLowerCase() === debouncedText.toLowerCase() ? (
        <span key={i} style={{ color: '#0567F9' }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const renderDataList = (item, index) => {
    const { address } = item;
    return (
      <div key={`list_${index}`} className="main-wrapper">
        <div className="address-main" onClick={() => onSelectItem(item)}>
          <div className="main-contents">{highlightSearchKeyword(address)}</div>
        </div>
      </div>
    );
  };

  return (
    <Dialog fullWidth={true} maxWidth="small" onClose={null} open={open}>
      <div className="address-popup">
        <div className="address-popup-header">
          <div className="popup-header-title">
            <IntlMessages id="button.searchAddress" />
          </div>
          <div className="address-popup-search-wrapper">
            <div className="address-popup-search-input">
              <input type="text" placeholder={formatMessage({ id: 'button.searchAddress' })} value={searchKeyword} onChange={({ target: { value } }) => setSearchKeyword(value)} autoFocus />
            </div>
            <div className="address-popup-search-button-wrapper">
              <img className="address-popup-search-button" {...searchButtons} alt="search" />
            </div>
          </div>
        </div>
        <div className="close-button">
          <img {...closeButtons} alt="close" onClick={onClose} />
        </div>
        {data.length === 0 ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '570px', color: '#999' }}>
            <IntlMessages id="common.address" />
          </div>
        ) : (
          <div className="address-popup-main">
            <div className="address-popup-main-wrapper">{data.map(renderDataList)}</div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default AddressVietnamPopup;
